
export { millisecondsInDay } from "/app/packages/data-formatting/src/dateConstants.ts"